import type { BucketColorInfo } from '~/store/frontendState/mapTools/boundary/boundarySelect/boundarySelect.state';

export const removeFromAllSelectionColorInfo: BucketColorInfo = {
  fillColor: '#000',
  fillOpacity: .7,
  borderColor: '#F00',
  borderOpacity: 1,
  borderWidth: 3,
};

export const defaultNextSelectionColorInfo: BucketColorInfo = {
  fillColor: '#FF0',
  fillOpacity: 0.4,
  borderColor: '#000',
  borderOpacity: 1,
  borderWidth: 1,
};
